import React from "react";
import { Line } from "react-chartjs-2";
import { getCommonOptions } from "./cardConfig";
import CustomLegends from "./CustomLegends";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import {
  getPeriodDates,
  isDatasetsDataEmpty,
  isValidChartData,
} from "../../Data/options";
import NoSubscription from "../NoSubscription";
import moment from "moment";
import { OverlayTrigger, Tooltip as ReactBootstrapTooltip } from "react-bootstrap";

const LineChartCard = ({
  data,
  chartTitle,
  formatType,
  metric,
  isDummyData,
  noSubscription,
  layoutItem,
  periodValue,
  showTimePeriod,
  DateRange,
}) => {
  const aspectRatio = layoutItem ? layoutItem?.w / layoutItem.cols : 1;

  const renderLineChart = () => {
    if (!data || !isValidChartData(data)) {
      return <>Something went wrong.</>;
    }
    const datasets = data.datasets?.map((x: any) => x);
    const commonOptions: any = getCommonOptions(
      formatType,
      metric,
      isDummyData
    );

    const lineOptions: any = {
      ...commonOptions,
      cubicInterpolationMode: "monotone",
      pointRadius: 0,
      plugins: {
        ...commonOptions.plugins,
        tooltip: {
          mode: "nearest",
          intersect: false,
          ...commonOptions.plugins.tooltip,
          titleFont: {
            family: "OpenSans",
          },
          bodyFont: {
            family: "OpenSans",
          },
          footerFont: {
            family: "OpenSans",
          },
          callbacks: {
            ...commonOptions.plugins.tooltip.callbacks,
            title: (tooltipItem) => {
              if (!isDummyData && tooltipItem.length > 0) {
                const label =
                  tooltipItem[0].dataset?.formattedDate[
                    tooltipItem[0].dataIndex
                  ];
                return label;
              }
            },
          },
        },
      },
      scales: {
        x: {
          ticks: {
            autoSkip: false,
            display: noSubscription ? false : true,
            color: "#84888C",
            font: {
              family: "OpenSans",
              size: 12,
            },
            // maxTicksLimit: 12, // Maximum number of ticks to display
          },
          grid: { color: "#F4F6F8" },
          title: {
            display: noSubscription ? false : true,
            text: "Months",
            color: "#84888C",
            font: {
              family: "OpenSans",
              size: 12,
            },
          },
        },
        y: {
          ...commonOptions.scales.y,
          ticks: {
            display: noSubscription ? false : true,
            ...commonOptions.scales.y.ticks,
            color: "#84888C",
            font: {
              family: "OpenSans",
              size: 12,
            },
          },
          title: {
            ...commonOptions.scales.y.title,
            display: noSubscription ? false : true,
            color: "#84888C",
            font: {
              family: "OpenSans",
              size: 12,
            },
          },
        },
      },
    };

    return (
      <>
        {noSubscription ? (
          <NoSubscription
            isNoHidsSelected={noSubscription == 2}
            subscription={metric?.moduleNames}
          />
        ) : (
          <></>
        )}
        <Line data={data} options={lineOptions} />
        {noSubscription ? (
          <></>
        ) : (
          <CustomLegends isLine={true} datasets={datasets} />
        )}
      </>
    );
  };

  let FromDate, ToDate;
  if (showTimePeriod) {
    ({ FromDate, ToDate } = DateRange || {});
  }

  const PeriodType =
    periodValue == 5 ? "YTD" : periodValue == 4 ? "Trailing 12" : periodValue == 1 ? "Current Period" :null
;

  return (
    <div
      className={`line-chart-metric chart-metric ${
        aspectRatio < 0.4 ? "view-1-3" : ""
      }`}
      style={{ width: "100%", margin: "0 auto" }}
    >
      <h2 className="chart-heading" style={{ whiteSpace: "pre-wrap" }}>
        <div className="d-flex">
          <EllipsisWithTooltip placement="top">
            {chartTitle}{" "} 
          </EllipsisWithTooltip>
          {showTimePeriod && <div className="badge"><EllipsisWithTooltip placement="bottom">{`Showing ${PeriodType} ${FromDate} - ${ToDate}`}
          
            </EllipsisWithTooltip><span>
            <OverlayTrigger
                placement="top"
                delay={{ show: 100, hide: 200 }}
                overlay={
                  <ReactBootstrapTooltip id={"chartInfo"}>
                    This Data can only be shown on a month by month basis
                  </ReactBootstrapTooltip>
                }>
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" version="1.1" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z"></path><path d="M10 12h-4v-1h1v-3h-1v-1h3v4h1z"></path><path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"></path></svg>
                  </OverlayTrigger>
              </span></div>
            }
        </div>
      </h2>
      {renderLineChart()}
    </div>
  );
};

export default React.memo(LineChartCard);
